(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kata-visual-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kata-visual-story')) {
    customElements.define('kata-visual-story', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
      }
      initialize() {
        if (this.classList.contains('kata-visual--strip')) { this.startStrip(); return; }
        if (!this.classList.contains('kata-visual--slider')) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.kata-visual__track');
        const prev = this.querySelector('[data-kv-prev]');
        const next = this.querySelector('[data-kv-next]');
        const update = () => {
          prev.disabled = this.track.scrollLeft <= 2;
          next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        };
        const move = direction => {
          const card = this.track.querySelector('.kata-visual__card');
          const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
          this.track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        prev.addEventListener('click', () => move(-1), {signal});
        next.addEventListener('click', () => move(1), {signal});
        this.track.addEventListener('scroll', update, {signal, passive:true});
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, {signal});
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.kata-visual__card');
          if (card) this.track.scrollTo({left:card.offsetLeft - this.track.firstElementChild.offsetLeft, behavior:'instant'});
        }, {signal});
        this.resize = new ResizeObserver(update);
        this.resize.observe(this.track);
        update();
      }
      startStrip() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const track = this.querySelector('.kata-visual__track');
        const toggle = this.querySelector('[data-strip-toggle]');
        const originals = Array.from(track.children);
        if (originals.length < 2) { toggle.hidden = true; return; }
        this.clones = originals.map(card => {
          const copy = card.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.inert = true;
          copy.removeAttribute('data-shopify-editor-block');
          copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          track.append(copy);
          return copy;
        });
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        let stopped = false, hovering = false, touching = false, focused = false;
        let resumeAt = 0, previous = 0, position = track.scrollLeft;
        let cycle = 0;
        const measure = () => { cycle = this.clones[0].offsetLeft - originals[0].offsetLeft; };
        this.resize = new ResizeObserver(measure);
        this.resize.observe(track);
        measure();
        toggle.addEventListener('click', () => {
          stopped = !stopped;
          toggle.setAttribute('aria-pressed', String(stopped));
          toggle.setAttribute('aria-label', stopped ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        }, {signal});
        track.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') hovering = true; }, {signal});
        track.addEventListener('pointerleave', () => { hovering = false; }, {signal});
        track.addEventListener('pointerdown', () => { touching = true; }, {signal});
        const release = () => { touching = false; focused = track.matches(':focus-visible'); resumeAt = performance.now() + 2500; };
        window.addEventListener('pointerup', release, {signal});
        window.addEventListener('pointercancel', release, {signal});
        track.addEventListener('focusin', event => { focused = event.target.matches(':focus-visible'); }, {signal});
        track.addEventListener('focusout', () => { focused = false; resumeAt = performance.now() + 4000; }, {signal});
        track.addEventListener('wheel', () => { resumeAt = performance.now() + 4000; }, {signal, passive:true});
        this.addEventListener('shopify:block:select', () => { resumeAt = performance.now() + 4000; }, {signal});
        const frame = now => {
          const delta = Math.min(now - previous, 50);
          previous = now;
          if (!stopped && !hovering && !touching && !focused && !reduced.matches && !document.hidden && now >= resumeAt && cycle > 0) {
            position = (position + delta * 0.025) % cycle;
            track.scrollLeft = position;
          } else {
            position = track.scrollLeft;
          }
          this.stripFrame = requestAnimationFrame(frame);
        };
        this.stripFrame = requestAnimationFrame(frame);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.stripFrame);
        this.clones?.forEach(clone => clone.remove());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
